module.exports = __webpack_public_path__ + "static/img/frack1new.aa7b5e40.png";